import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FieldTimeRangePicker, FlexBox, IconButton, Text, } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useCallback, useState } from 'react';
import { usePrevious, usePreviousDistinct, useUpdateEffect } from 'react-use';
import { defaultTime } from 'utils/date';
import styles from './intervalsSelect.module.scss';
import { getNewIntervals } from './utils/intervals';
const maxLengthOfIntervals = 10;
export const IntervalsSelect = ({ errors, isClosed, intervals: propIntervals, onChange, validate, }) => {
    const timeFormat = moment.localeData().longDateFormat('LT');
    const [intervals, setIntervals] = useState(propIntervals);
    const previousIntervals = usePreviousDistinct(intervals);
    const previousIsClosed = usePrevious(isClosed);
    useUpdateEffect(() => void onChange(intervals), [intervals]);
    const handleTimeChange = useCallback((index) => ({ startTime: start, endTime: end, }) => {
        setIntervals((prevIntervals) => {
            const newIntervals = [...prevIntervals];
            newIntervals[index] = { start, end };
            if (newIntervals.length > 1) {
                validate(newIntervals);
            }
            return newIntervals;
        });
    }, [validate]);
    const handleAddNewIntervals = useCallback(() => {
        setIntervals((prevIntervals) => {
            const newIntervals = getNewIntervals(prevIntervals[prevIntervals.length - 1]);
            const newStateIntervals = [...prevIntervals, newIntervals];
            validate(newStateIntervals);
            return newStateIntervals;
        });
    }, [validate]);
    useUpdateEffect(() => {
        if (previousIsClosed !== isClosed) {
            const newIntervals = isClosed ? [] : previousIntervals || [defaultTime];
            if (isClosed || newIntervals.length > 1) {
                validate(newIntervals);
            }
            setIntervals(newIntervals);
        }
    }, [isClosed, previousIntervals, previousIsClosed]);
    const handleDeleteInterval = useCallback((index) => () => {
        setIntervals((prevIntervals) => {
            const newIntervals = [...prevIntervals];
            newIntervals.splice(index, 1);
            validate(newIntervals);
            return newIntervals;
        });
    }, [validate]);
    return (intervals === null || intervals === void 0 ? void 0 : intervals.length) && !isClosed ? (_jsx(_Fragment, { children: intervals.map(({ start: startTime, end: endTime }, index) => (_jsxs(FlexBox, Object.assign({ alignItems: "flex-start" }, { children: [_jsx(FieldTimeRangePicker, { allowCustomTimeInput: true, className: styles.timeRangePicker, dropdownProps: { fixed: true }, input: {
                        name: 'opening-hours',
                        onChange: handleTimeChange(index),
                        value: { startTime, endTime },
                    }, meta: {
                        error: errors[index],
                    }, noLabel: true, overrides: [{ hour: 23, minute: 59 }], timeFormat: timeFormat }), index === 0 ? (_jsx(IconButton, { className: styles.icon, disabled: (intervals === null || intervals === void 0 ? void 0 : intervals.length) >= maxLengthOfIntervals, icon: "plus", onClick: handleAddNewIntervals, variant: "tertiary" })) : (_jsx(IconButton, { className: styles.icon, icon: "trash", variant: "tertiary", onClick: handleDeleteInterval(index) }))] }), `name-${index}`))) })) : (_jsx(Text.Paragraph, Object.assign({ className: styles.closed }, { children: "Closed" })));
};
